<div class="dialog-container">
  <h2 mat-dialog-title>Save as</h2>
  <div mat-dialog-content>
    <mat-form-field appearance="outline" class="w-100">
      <input matInput [(ngModel)]="reportName" placeholder="CTT Pricing Impact">
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button class="btn-ok" (click)="onSave()" [disabled]="!reportName">Ok</button>
    <button mat-button class="btn-cancel" (click)="onCancel()">Cancel</button>
  </div>
</div>
